<template>
  <div class="create-store">
    <el-dialog
      v-model="dialogVisible"
      :title="
        formData.menuId
          ? $t('MenuConfig.Edit Menu')
          : $t('MenuConfig.Create Menu')
      "
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
      {{ formData }}
      <div class="form-box">
        <el-form
          label-width="160px"
          style="width: 100%"
          :model="formData"
          ref="form"
          :rules="rules"
          size="small"
        >
          <el-form-item :label="$t('MenuConfig.Menu ParentId')" prop="parentId">
            <el-cascader
              v-model="formData.parentId"
              :options="options"
              :props="{
                checkStrictly: true,
                children: 'childMenu',
                label: 'name',
                value: 'menuId',
                expandTrigger: 'hover',
              }"
              clearable
              style="width: 320px"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('MenuConfig.Menu Type')" prop="nodeType">
            <el-radio-group v-model="formData.nodeType">
              <el-radio :label="0">{{ $t("MenuConfig.Menu Type0") }}</el-radio>
              <el-radio :label="1">{{ $t("MenuConfig.Menu Type1") }}</el-radio>
              <el-radio :label="2">{{ $t("MenuConfig.Menu Type2") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('MenuConfig.Menu Name')" prop="name">
            <el-input v-model="formData.name" placeholder="" clearable />
          </el-form-item>
          <el-form-item :label="$t('MenuConfig.Name Translate')">
            <el-input placeholder="" readonly>
              <!-- <template #append>
                <div @click="selectLanguage">
                  {{ $t("scenarioConfig.Details") }}...
                </div>
              </template> -->
            </el-input>
            <div class="scenario-form-language" @click="selectLanguage">
              {{ $t("scenarioConfig.Details") }}...
            </div>
          </el-form-item>

          <el-form-item :label="$t('MenuConfig.Menu Code')" prop="menuCode">
            <el-input v-model="formData.menuCode" placeholder="" clearable />
          </el-form-item>
          <el-form-item
            v-if="formData.nodeType == 0"
            :label="$t('MenuConfig.Menu Icon')"
            prop="iconUrl"
          >
            <el-input v-model="formData.iconUrl" placeholder="" clearable />
          </el-form-item>
          <el-form-item :label="$t('MenuConfig.Menu Sort')" prop="sort">
            <el-input v-model="formData.sort" placeholder="" clearable />
          </el-form-item>
          <el-form-item
            v-if="formData.nodeType == 1"
            :label="$t('MenuConfig.Menu Path')"
            prop="path"
          >
            <el-input v-model="formData.path" placeholder="" clearable />
          </el-form-item>
          <el-form-item
            v-if="formData.nodeType == 1"
            :label="$t('MenuConfig.Menu Linkurl')"
            prop="linkUrl"
          >
            <el-input v-model="formData.linkUrl" placeholder="" clearable />
          </el-form-item>

          <!-- 保存按钮 -->
          <div class="form-btn-section">
            <el-button
              color="#28C76F"
              size="small"
              @click="dialogVisible = false"
              >{{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="onSubmit"
              >{{ $t("button.Save") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 语言弹窗 -->

    <languageSelect
      :visible="langDialogVisible"
      :languageList="formData.nameTranslate"
      @close="closeLanguage"
      @message="setLanguageConfig"
    >
    </languageSelect>
  </div>
</template>
<script>
import { trim } from "lodash";
import languageSelect from "./languageSelect.vue";
import { createMenu, updateMenu } from "@/libs/api/menu";
let loading;

export default {
  name: "createMenu",
  components: { languageSelect },
  props: {
    statusList: {
      type: Array,
    },
    editData: {
      type: Object,
    },
    menuList: {
      type: Array,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      options: [
        {
          name: "主类目",
          menuId: "0",
          parentId: "",
          childMenu: [],
        },
      ],
      dialogVisible: false,
      langDialogVisible: false,
      initFormData: {
        menuId: '',
        name: "", // 菜单名称
        parentId: "", // 上级节点
        menuCode: "", // 菜单编码，用于后端权限控制
        nameTranslate: [
          //	菜单多语言翻译
          {
            text: "", // 列名
            language: "", //	列值
          },
        ],
        nodeType: "", // 节点类型：0：文件夹，1：页面，2：按钮
        iconUrl: "", //	图标地址
        sort: "", // 排序
        path: "", // 树id的路径，整个层次上的路径id，逗号分隔，方便查找父级节点
        linkUrl: "", // 页面对应的地址
      },
      formData: {
        menuId: '',
        name: "", // 菜单名称
        parentId: "", // 上级节点
        menuCode: "", // 菜单编码，用于后端权限控制
        nameTranslate: [
          //	菜单多语言翻译
          {
            text: "", // 列名
            language: "", //	列值
          },
        ],
        nodeType: "", // 节点类型：0：文件夹，1：页面，2：按钮
        iconUrl: "", //	图标地址
        sort: "", // 排序
        path: "", // 树id的路径，整个层次上的路径id，逗号分隔，方便查找父级节点
        linkUrl: "", // 页面对应的地址
      },
      rules: {
        linkUrl: "", // 页面对应的地址
        name: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
        parentId: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
        menuCode: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
        nodeType: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
        path: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
        linkUrl: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  watch: {
    editData: function (val) {
      console.log("--watch--editData", val);
      if (val && val.menuId) {
        let data = {
          ...val,
          nameTranslate: JSON.parse(val.nameTranslate),
        };
        this.formData = data;
      } else {
        let obj = { ...this.initFormData };
        this.formData = obj;
      }
    },
    menuList: function (val) {
      console.log("--watch--menuList111111", val);
    },

    menuList: {
      handler(val, oval) {
        console.log("--watch--menuLis222222", val);
        if (val) {
          console.log(val);
          console.log("--watch--menuLis333333val");
          this.options[0].childMenu = val;
          console.log(this.options);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setLanguageConfig(data) {
      console.log("语言弹窗确定", data);
      this.formData.nameTranslate = data;
      // if(this.formData.menuId){
      //   this.isModifyLanguage = true
      //   this.scenlisupdate()
      // }
    },
    // 选择语言弹窗
    selectLanguage() {
      this.langDialogVisible = true;
      console.log("选择语言", this.langDialogVisible);
    },
    closeLanguage() {
      console.log("测试closeLanguage");
      this.langDialogVisible = false;
    },
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 表单提交
    onSubmit() {
      loading = this.$loading({
        text: "loading...",
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log(this.formData);
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单校验通过");
          this.menuCreate();
        } else {
          loading.close();
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 请求--- 创建菜单/更新菜单
    async menuCreate() {
      let res = null;
      try {
        const lastParentId = this.formData.parentId.length - 1;

        if (this.formData.menuId) {
          const params = {
            ...this.formData,
          };
          res = await updateMenu(params);
        } else {
          const params = {
            ...this.formData,
            parentId: this.formData.parentId[lastParentId],
          };
          res = await createMenu(params);
        }
        let response = res.data;
        if (response.state) {
          let message = this.$t("commonMessage.CreateSucess");
          if (this.formData.menuId) {
            message = this.$t("commonMessage.ModifySucess");
          }
          this.$message({
            message: message,
            type: "success",
          });
          this.dialogVisible = false;
          this.$emit("getData");
          loading.close();
        } else {
          loading.close();
          this.$message.error(response.message);
        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.create-store {
  .form-box {
    width: 480px;
    margin: 0 auto;
    min-height: 300px;
  }
  .section-tit {
    position: relative;
    font-weight: 600;
    padding: 10px 10px 10px 20px;
    background: whitesmoke;
    margin-bottom: 20px;
    border-radius: 4px;
    .flag {
      position: absolute;
      width: 4px;
      height: 18px;
      border-radius: 2px;
      background: #35b871;
      top: 0px;
      bottom: 0px;
      left: 10px;
      margin: auto;
    }
  }

  .form-btn-section {
    width: 100%;
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    ::v-deep .el-button {
      width: 110px;
    }
  }
  // 重置样式
  ::v-deep .el-dialog {
    margin-top: 5vh !important;
  }
  ::v-deep .el-dialog__body {
    max-height: calc(82vh);
    overflow-y: scroll;
  }
  .el-select {
    width: 100%;
  }
  .el-button--success {
    width: 100%;
  }
}
.scenario-form-language {
  background: #3461ff;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 3px;
  padding: 0px 20px;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
}
</style>